import {
  Component,
  Injector, OnInit,
  Optional
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, provideAsWidgetRef, Parent, register, styler, StylableComponent } from "@wm/components-base";
import {DatasetAwareNavComponent} from "./dataset-aware-nav.component";
import {addClass, removeClass} from "@wm/core";

const DEFAULT_CLS = 'nav app-nav';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-nav',
  hostClass: DEFAULT_CLS,
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};
const NavClassMap: any = {
  pills: 'nav-pills',
  tabs: 'nav-tabs',
  navbar: 'navbar-nav'
};
@Component({
  selector: '[wmNav]',
  template: `
    <ng-template #menuRef let-item="item" let-index="index">
      <div wmMenu dropdown
           type="anchor"
           autoclose.bind="autoclose"
           iconclass.bind="item.icon"
           autoopen.bind="autoopen"
           caption.bind="item.label"
           dataset.bind="item.children"
           badgevalue.bind="item.badge"
           iconposition.bind="iconposition"></div>
    </ng-template>

    <ng-template #anchorRef let-item="item" let-index="index">
      <a wmAnchor
         caption.bind="item.label"
         iconclass.bind="item.icon"
         badgevalue.bind="item.badge"
         iconposition.bind="iconposition"></a>
    </ng-template>

    <li class="app-nav-item {{item.class}}" *ngFor="let item of nodes; let index = index;" >
      <ng-container [ngTemplateOutlet]="anchorRef" [ngTemplateOutletContext]="{item: item, index:index}" *ngIf="!item?.children?.length"></ng-container>
      <ng-container [ngTemplateOutlet]="menuRef" [ngTemplateOutletContext]="{item: item, index:index}"  *ngIf="item?.children?.length"></ng-container>
    </li>

    <ng-content *ngIf="!nodes.length" select="[wmNavItem]"></ng-content>

  `,
  providers: [
    provideAsWidgetRef(NavComponent)
  ],
  exportAs: 'wmNav',
  standalone: true,
  imports: [ CommonModule ],
  styles: []
})
export class NavComponent extends DatasetAwareNavComponent implements OnInit{
  static initializeProps = register('wm-nav');

  public selecteditem: any;
  public type: any;
  public disableMenuContext: boolean;
  public layout: any;
  public nodeElements: any;

  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setNavType(this.type);
    this.setNavLayout(this.layout);
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'type'){
      this.setNavType(nv,ov);
    }
    if (key === 'layout'){
      this.setNavLayout(nv,ov);
    }
    super.onPropertyChange(key, nv, ov);
  }

  private setNavType(type: string,oldValue?: string) {
    if (oldValue){
      removeClass(this.nativeElement,NavClassMap[oldValue])
    }
    addClass(this.nativeElement, NavClassMap[type]);
  }

  private setNavLayout(layout: any,oldValue?:string) {
    if (oldValue){
      removeClass(this.nativeElement,`nav-${oldValue}`);
    }
    addClass(this.nativeElement, `nav-${layout}`);
  }

}

